module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"filters":"Все фильтры","filters-date":"Фильтр по дате","workspace":"Рабочая область"},"en":{"filters":"Filters","filters-date":"Date filters","workspace":"Workspace"}}')
  delete Component.options._Ctor
}
